import React from 'react';
import PropTypes from "prop-types";
import CallScoreFactorDetails from "./CallScoreFactorDetails";

const CallScoreFactors = ({factors}) => {

    return factors?.map((factor, index) => {
        return (
            <CallScoreFactorDetails
                key={index}
                title={factor.name}
                actualScore={factor.score}
                totalScore={100}
                summary={factor?.summary}
                whatWorked={factor?.feedback?.positive?.summary}
                whatDidNotWork={factor?.feedback?.negative?.summary}
                howCouldItBeImproved={factor?.feedback?.how_could_it_be_improved}
            />
        );
    })
};

CallScoreFactors.prototype = {
    factors: PropTypes.shape({
        communicationAndEngagement: PropTypes.shape({
            actual: PropTypes.number,
            total: PropTypes.number,
            feedback: PropTypes.shape({
                what_worked: PropTypes.string,
                what_did_not_work: PropTypes.string,
                how_could_it_be_improved: PropTypes.string
            })
        }),
        forwardMonitor: PropTypes.shape({
            actual: PropTypes.number,
            total: PropTypes.number,
            feedback: PropTypes.shape({
                what_worked: PropTypes.string,
                what_did_not_work: PropTypes.string,
                how_could_it_be_improved: PropTypes.string
            })
        }),
        questionHandling: PropTypes.shape({
            actual: PropTypes.number,
            total: PropTypes.number,
            feedback: PropTypes.shape({
                what_worked: PropTypes.string,
                what_did_not_work: PropTypes.string,
                how_could_it_be_improved: PropTypes.string
            })
        }),
        salesProcess: PropTypes.shape({
            actual: PropTypes.number,
            total: PropTypes.number,
            feedback: PropTypes.shape({
                what_worked: PropTypes.string,
                what_did_not_work: PropTypes.string,
                how_could_it_be_improved: PropTypes.string
            })
        })
    })
}

export default CallScoreFactors;

